export enum ELocale {
  ru = "ru",
  en = "en",
  es = "es",
  pt = "pt",
  uk = "uk",
  kk = "kk",
  ro = "ro",
}

export type IContextLanguage = {
  changeLanguage: (locale: ELocale) => Promise<void>;
};
